<template src="./index.html"></template>
<script>
	import {
		getdata
	} from "./data.js";
	import {
		qualifications,
		querycomapny,
		sumcomapny,
		sum,
		save_sum,
		companyaptitudepage,
		sapsubjectcodespage,
		aptitudeConfigsave
	} from "../../../../../api/riskManagement.js"
	import config from "../../../../../../configHttp.js"
	import {
		fxjk_comapny,
	} from '../../../../../api/Notificationsettings.js';
	export default {
		name: "",
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
				pagination: getdata().pagination,
				tableData: getdata().tableData,
				choosediag: false,
				headDatachoose: getdata().headDatachoose,
				tableDatachoose: [],
				sjtxdiag: false,
				suosq: this.$getdefultMonth(),
				tksuosq: this.$getdefultMonth(),
				comapny: null,
				headDatasj: getdata().headDatasj,
				tableDatasj: [{
					title: "嵌入式软件收入(自主)",
					titlesq: []
				}, {
					title: "购入式软件收入",
					titlesq: []
				}, {
					title: "软件总收入",
					titlesq: []
				}, {
					title: "纯软件产品收入",
					titlesq: []
				}, {
					title: "企业收入总额",
					titlesq: []
				}],
				tablekey: 0,
				headDatasetting: getdata().headDatasetting,
				paginationSetting: getdata().paginationSetting,
				tableDatasetting: [],
				settingdiag: false,
				options: [],
				value: '',
				subjectCode: "",
				indexScale: "",
				companyType: null,
				detailid: null,
				subjectJson:[]
			};
		},
		created() {},
		mounted() {
			this.setup()
		},
		methods: {
			checkchoose(){
				let chooseval= this.$refs.tablesetting.getSelectionval()
				if(chooseval.length){
					this.tableDatasetting.forEach((gtem,index)=>{
						if(chooseval.map(item=>item.subjectCode).includes(gtem.subjectCode)){
							if(!this.subjectJson.includes(gtem.subjectCode)){
								this.subjectJson.push(gtem.subjectCode)
							}
						}else{
							if(this.subjectJson.includes(gtem.subjectCode)){
								this.subjectJson.splice(index,1)
							}
						}
					})
				}else{
					this.subjectJson=this.subjectJson.filter(item=>!(this.tableDatasetting.map(gtem=>gtem.subjectCode).includes(item)))
				}
			},
			async forsearchSetting() {
				this.checkchoose()
				this.paginationSetting.pageNum = 1
				this.tablekey++
			 let states=await this.sapsubjectcodespage()
			 if(states){
				let toge = this.tableDatasetting.filter(item => this.subjectJson.includes(item.subjectCode))
				this.$nextTick(() => {
					this.$refs.tablesetting.toggleSelection(toge)
				}); 
			 }
			},
			forsetting() {
				if (this.$emptyandnull(this.value)) {
					this.$message.error("公司名称不能为空")
					return false
				}
				if (this.$emptyandnull(this.companyType)) {
					this.$message.error("企业类型不能为空")
					return false
				}
				if (this.$emptyandnull(this.indexScale)) {
					this.$message.error("通用比率不能为空")
					return false
				}
				this.checkchoose()
				let params = {
					"companyNo": this.value,
					"companyType": this.companyType,
					"id": this.detailid,
					"indexScale": this.indexScale,
					"subjectJson":this.subjectJson[0] ?  this.subjectJson: []
				}
				aptitudeConfigsave(params).then(res => {
					if (res.data.code == 1) {
						this.settingdiag = false;
						this.setup()
						this.$message.success(res.data.msg)
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			//查公司
			fxjk_comapny() {
				return new Promise((resolve, reject) => {
					fxjk_comapny().then(res => {
						this.options = res.data.data.map(v => {
							return {
								value: v.companyNo,
								label: v.nsrmc
							};
						});
						this.value = this.options[0].value
						this.options = JSON.parse(JSON.stringify(this.options))
						resolve(true)
					})
				})
			},
			sapsubjectcodespage() {
				return new Promise((resolve, reject) => {
					let params = {
						subjectCode: this.subjectCode,
						current: this.paginationSetting.pageNum,
						size: 10000,
					}
					sapsubjectcodespage(params).then(res => {
						this.tableDatasetting = res.data.data.records
						this.paginationSetting.total = res.data.data.total
						resolve(true)
					})
				})
			},
			companyaptitudepage() {
				return new Promise((resolve, reject) => {
					companyaptitudepage({
						companyNo: this.value
					}).then(res => {
						this.settingdiag=true
						let arr = res.data.data.records
						if (arr[0]) {
							this.indexScale = arr[0].indexScale
							this.companyType = arr[0].companyType
							this.detailid = arr[0].id
							if (arr[0].subjectJson) {
								this.subjectJson = JSON.parse(arr[0].subjectJson)
								let toge = this.tableDatasetting.filter(item => this.subjectJson.includes(item.subjectCode))
								this.$nextTick(() => {
									this.$refs.tablesetting.toggleSelection(toge)
								});
							}
						} else {
							this.subjectJson = [],
								this.indexScale = "",
								this.companyType = null,
								this.detailid = null
						}
						resolve(true)
					})
				})
			},
			async forsz(){
				let statefxjk = await this.fxjk_comapny()
				if(statefxjk){
					this.subjectCode=""
					let statesapsubject = await this.sapsubjectcodespage()
					if(statesapsubject){
						this.companyaptitudepage()
					}
				}
			},
			async changeCompany(e) {
				this.subjectCode=""
				let statesapsubject = await this.sapsubjectcodespage()
				if(statesapsubject){
					this.companyaptitudepage()
				}
			},
			
			nextdc() {
				let params = {
					downUrl: config.baseURL + '/report/exprot/sum',
					typeObj: {
						toForm: false,
						fileName: "相关资质",
						fileType: 'xlsx',
					},
					params: {
						suosq: this.suosq
					}
				}
				this.$downloadcommon(params)
			},
			tksuosqchange() {
				this.choosed();
			},
			choosed() {
				this.headDatasj = []
				let params = {
					suosq: this.tksuosq
				}
				sum(params).then(res => {
					if (res.data.code == 1) {
						if (res.data.data.length == 0) {
							this.headDatasj = [{}]
						} else {
							this.headDatasj = res.data.data
						}
					}
					this.sjtxdiag = true
				})
			},
			nextsj() {
				let params = {
					"comapnySum": this.headDatasj,
					"suosq": this.tksuosq
				}
				save_sum(params).then(res => {
					if (res.data.code == 1) {
						this.sjtxdiag = false;
						this.suosqchange();
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			nextcompan() {
				let oulist = this.$refs.tablebox_on.getSelectionval()
				let params = {
					suosq: this.suosq,
					companyInfo: oulist
				}
				sumcomapny(params).then(res => {
					if (res.data.code == 1) {
						this.$message.success('选择成功')
						this.choosediag = false
						this.setup()
					} else {
						this.$message.error(res.data.msg)
					}
				})
				// 重新调用查询
				this.setup();
			},
			compan() {
				querycomapny().then(res => {
					if (res.data.code == 1) {
						let list = []
						this.tableDatachoose = res.data.data
						this.tableDatachoose.map(item => {
							this.comapny.map(item1 => {
								if (item.companyCode == item1.companyCode) {
									list.push(item)
								}
							})
						})
						this.choosediag = true
						this.$nextTick(() => {
							this.$refs.tablebox_on.toggleSelection(list)
						})
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			suosqchange() {
				this.pagination.pageNum = 1
				this.pagination.paginationkey++
				this.setup()
			},
			sx() {
				this.setup()
			},
			setup() {
				let params = {
					suosq: this.suosq
				}
				qualifications(params).then(res => {
					if (res.data.code == 1) {
						this.headData[4].children = []
						this.comapny = res.data.data
						for (let a = 0; a < res.data.data.length; a++) {
							this.headData[4].children.push({
								title: res.data.data[a].companyCode,
								prop: "gsdm" + a
							}, )
							this.tableData.map(item => {
								Object.keys(res.data.data[a]).map(key => {
									if (item[key]) {
										item["gsdm" + a] = res.data.data[a].companyCode
									}
									if (res.data.data[a][key]) {
										Object.keys(item).map(keys => {
											if (item[keys] == key) {
												if(res.data.data[a]
													[key] !='--'){
												item["gsdm" + a] = res.data.data[a]
													[key] + '%'
												}else{
												item["gsdm" + a] = res.data.data[a]
													[key]
												}
											}
										})
									}
								})
							})
						}
						this.tableData = JSON.parse(JSON.stringify(this.tableData))
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			sizechange(e) {
				this.pagination.pageSize = e;
			},
			currentChange(e) {
				this.pagination.pageNum = e;
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex === 0) {
						return {
							rowspan: 1,
							colspan: 1
						};
					} else if (rowIndex === 1) {
						return {
							rowspan: 3,
							colspan: 1
						};
					} else if (rowIndex === 4) {
						return {
							rowspan: 1,
							colspan: 1
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
			},
		},
	};
</script>

<style scoped lang="less">
	@import url("./index.less");
</style>